import { Box, Container, Typography } from '@mui/material';
import Heading from 'components/Heading';
import ErrorPageLayout from 'components/layouts/ErrorPageLayout';
import React from 'react';

const ErrorPage: React.FC = () => (
  <ErrorPageLayout>
    <Container>
      <Box p={8}>
        <Heading pl={0} mb={4}>
          Error
        </Heading>
        <Typography component="p" variant="subtitle1">
          Something went wrong
        </Typography>
      </Box>
    </Container>
  </ErrorPageLayout>
);

export default ErrorPage;
